import { desktopBlockStyle } from "../styles";

import { names } from "../texts/personal";

export default function Welcome({
  isDark,
  isMobile,
  isVertical,
  setModalOpen,
  setContent,
  username,
}: PersonalProps) {
  const name = `${names[username]}${
    ["ilyur", "nasaf", "saftan"].includes(username) ? "я" : "а"
  }`;

  const isHorizontalMobile = isMobile && !isVertical;
  const isVerticalDesktop = !isMobile && isVertical;

  const desktopStyle = `flex ${desktopBlockStyle} px-0 pb-0 ${
    isVertical ? "sm:pt-10 tablet:pt-20" : "sm:pt-10 xl:pt-20"
  } relative`;
  const mobileStyle = `relative pt-16 justify-center`;

  const photoSource = `/welcome/welcome${isMobile ? "-mobile" : ""}.jpg`;
  const borderedPhoto = "/welcome/welcome-mobile-2.jpg";

  const smallerSide = window.visualViewport![isVertical ? "width" : "height"];
  const modalWidth = isVertical
    ? smallerSide * 0.8
    : isMobile
    ? smallerSide
    : smallerSide * 0.65;

  return (
    <div className={isMobile ? mobileStyle : desktopStyle}>
      <div className={`${isMobile ? "w-full" : "relative w-1/2"}`}>
        <div className="z-10">
          <img
            src={`/welcome/envilope-${isDark ? "dark" : "light"}.png`}
            alt="envilope"
            width={
              isMobile
                ? isHorizontalMobile
                  ? smallerSide * 0.45
                  : "300"
                : "450"
            }
          />
        </div>
        <div
          className={`absolute rounded-lg ${
            isDark ? "bg-gray-900" : "bg-red-100"
          } ${
            isMobile
              ? `top-10 left-[10vw] ${
                  isHorizontalMobile
                    ? "w-1/2 pb-4 top-4 h-full"
                    : "w-[80vw] pb-20"
                } px-4 items-center`
              : `flex flex-col w-2/3 top-10 left-32 gap-8 py-12 px-8 w-11/12 
              ${
                isVerticalDesktop
                  ? "h-min pb-40 sm:w-full lg:w-11/12"
                  : "sm:w-full xl:h-5/6 xl:w-5/6 2xl:w-2/3 h-full 3xl:h-2/5"
              }`
          } `}
        >
          <p
            className={`text-center
              ${
                isMobile
                  ? isHorizontalMobile
                    ? "pt-4 text-lg"
                    : "pt-4 text-xl"
                  : "text-2xl"
              }
            `}
          >
            Привет, {name}
          </p>
          <p
            className={
              isMobile
                ? isHorizontalMobile
                  ? "text-sm pt-4"
                  : "pt-4"
                : "text-lg"
            }
          >
            Мы благодарны за участие в нашем маленьком свадебном путешествии и в
            большом жизненном событии.
          </p>
          <p
            className={
              isMobile
                ? isHorizontalMobile
                  ? "pt-4 text-sm"
                  : "pt-4"
                : "text-lg"
            }
          >
            На этом сайте мы собрали самые интересные и тёплые моменты.
          </p>
          <p
            className={
              isMobile
                ? isHorizontalMobile
                  ? "pt-4 text-sm"
                  : "pt-4"
                : "text-lg"
            }
          >
            P.S. Фотографии открываются при нажатии.
          </p>
        </div>
      </div>
      <div
        className={
          isMobile
            ? "w-full"
            : `w-1/2 pt-32 pl-32 ${
                isVerticalDesktop ? "sm:h-screen" : "h-[94vh]"
              }`
        }
      >
        <div className="h-full relative">
          <div
            className={
              isMobile
                ? "hidden"
                : isVerticalDesktop
                ? `absolute sm:bottom-[10vh] sm:left-[-10vw] z-0 tablet:hidden`
                : `absolute lg:hidden xl:flex xl:pb-20 xl:bottom-0.5 
                2xl:bottom-0 3xl:bottom-1 right-0 z-0`
            }
          >
            <img
              src={`/welcome/flower-${isDark ? "dark" : "light"}.png`}
              style={{ opacity: 0.6 }}
              alt="flower"
              width={600}
            />
          </div>
          <div
            className={`${
              isMobile
                ? isHorizontalMobile
                  ? "absolute bottom-2 right-8"
                  : "absolute top-[-40vw] left-[30vw]"
                : "absolute top-8 2xl:top-[-2vw] 2xl:left-[-3vw]"
            } rotate-[20deg] 2xl:border-double 2xl:border-8 ${
              isDark ? "2xl:border-gray-600" : "2xl:border-red-200"
            } 2xl:p-2`}
          >
            <img
              src={isMobile ? borderedPhoto : photoSource}
              style={{ opacity: isDark ? 0.9 : 1 }}
              alt="welcome"
              width={isMobile ? (window.innerWidth < 321 ? 100 : 210) : 400}
              onClick={() => {
                setContent(
                  <img src={photoSource} alt="welcome" width={modalWidth} />
                );
                setModalOpen(true);
              }}
            />
          </div>
          <div
            className={
              isVerticalDesktop
                ? "sm:hidden tablet:flex absolute top-[40vh] left-[-60vw]"
                : "hidden"
            }
            style={{ opacity: 0.7 }}
          >
            <img src={`/placeholder-${isDark ? "dark" : "light"}.png`} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}
